import layoutUserPrefsView from './layoutUserPrefsComponent.html';

export function layoutUserPrefsComponent() {
	return {
		bindings: {},
		controllerAs: 'vm',
		transclude: true,
		template: layoutUserPrefsView,
	};
}
